import { render, staticRenderFns } from "./AdminKeyword.vue?vue&type=template&id=3ca82009&"
import script from "./AdminKeyword.vue?vue&type=script&lang=js&"
export * from "./AdminKeyword.vue?vue&type=script&lang=js&"
import style0 from "./AdminKeyword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports